import { useAxios } from "./useAxios"

export type AutoCompleteOptions = {
  id: number
  label: string
}

export type LookupTables = {
  affiliationCustomers: (AutoCompleteOptions & { dependence_id: number })[]
  affiliations: (AutoCompleteOptions & { tag: string })[]
  countries: AutoCompleteOptions[]
  courseTypes: (AutoCompleteOptions & { tag: string, course_type_gpa_add: number })[]
  creditStatusTypes: (AutoCompleteOptions & { tag: string })[]
  creditTypes: (AutoCompleteOptions & { tag: string })[]
  currencies: (AutoCompleteOptions & { sign: string })[]
  currentAcademicTerm: AutoCompleteOptions & { academic_start_date: string, academic_end_date: string, year: number }
  currentTerm: AutoCompleteOptions & { term_start_date: string, term_end_date: string, year: number }
  customerTypes: AutoCompleteOptions[]
  elementaryExamTypes: AutoCompleteOptions[]
  genders: AutoCompleteOptions[]
  gpaGradeScaleTypes: AutoCompleteOptions[]
  grades: AutoCompleteOptions[]
  lms: AutoCompleteOptions[]
  programs: (AutoCompleteOptions & { fk_id_school_stage: number })[]
  paymentMethods: AutoCompleteOptions[]
  referenceYearForBillings: number[]
  referenceYearForBundles: number[]
  relationships: AutoCompleteOptions[]
  requestStatusTypes: (AutoCompleteOptions & { description: string })[]
  requestTypes: AutoCompleteOptions[]
  schoolStages: (AutoCompleteOptions & { tag: string })[]
  services: AutoCompleteOptions[]
  standards: (AutoCompleteOptions & { grade_specific: string, standard_short_code: string })[]
  states: (AutoCompleteOptions & { fk_id_country: number })[]
  studentStatusTypes: AutoCompleteOptions[]
  students: AutoCompleteOptions[]
  subjects: AutoCompleteOptions[]
  terms: (AutoCompleteOptions & { start_date: string, end_date: string, academic_start_date: string | null, academic_end_date: string | null, year: number })[]
  termsFuture: (AutoCompleteOptions & { term_start_date: string, term_end_date: string, year: number })[]
  termsPast: (AutoCompleteOptions & { term_start_date: string, term_end_date: string, year: number })[]
  termsUntilCurrentYear: (AutoCompleteOptions & { term_start_date: string, term_end_date: string, year: number })[]
  triggers: any[]
  examQuestionMaxScores: AutoCompleteOptions[]
  elementaryExamQuestionTypes: AutoCompleteOptions[]
}

function selectKeys<T, K extends keyof T>(lookupTables: T, keys: K[]): Pick<T, K> {
  const result = {} as Pick<T, K>;

  for (const key of keys) {
    result[key] = lookupTables[key]
  }

  return result
}

export function useLookupTables<K extends keyof LookupTables>(tables: K[]) {
  const { data, error, isLoading } = useAxios<LookupTables>(`${process.env.REACT_APP_MAIN_BACKEND_URL}/lookup-tables?${tables.map((_) => `tables[]=${_}`).join('&')}`)

  // console.log('[ Lookup Tables ]', data, process.env.REACT_APP_MAIN_BACKEND_URL, `${process.env.REACT_APP_MAIN_BACKEND_URL}/lookup-tables?${tables.map((_) => `tables[]=${_}`).join('&')}`)

  return {
    lookupTables: data ? selectKeys(data, tables) : null,
    isLoadingLookupTables: isLoading,
    errorLookupTables: error
  }
}